import { ThemePalette } from "@commonlibs";
import { basePalette } from "./basePalette";
import {
    OVERLAY_262626,
    OVERLAY_27292B,
    OVERLAY_3F4246,
    OVERLAY_A7A7A7,
    OVERLAY_757575,
    OVERLAY_FFFFFF,
    OVERLAY_EDEDED,
    OVERLAY_FBFBFB,
} from "./overlays";

export const gray: ThemePalette["gray"] = {
    0: "#FFFFFF",
    50: "#FBFBFB",
    100: "#EDEDED",
    300: "#A7A7A7",
    500: "#757575",
    600: "#3F4246",
    800: "#262626",
    900: "#27292B",
};

const overlays: ThemePalette["overlays"] = {
    0: OVERLAY_FFFFFF,
    50: OVERLAY_FBFBFB,
    100: OVERLAY_EDEDED,
    300: OVERLAY_A7A7A7,
    500: OVERLAY_757575,
    600: OVERLAY_3F4246,
    800: OVERLAY_262626,
    900: OVERLAY_27292B,
};

const text = gray[900];
export const borderSm = `1px solid ${overlays[800][8]}`;
export const borderMd = `2px solid ${overlays[800][8]}`;
const light = gray[300];

export const lightPalette: Partial<ThemePalette> = {
    mode: "light",
    ...basePalette,
    overlays,
    gray,
    disabled: overlays[800][8],
    background: gray[0],
    backdrop: overlays[800]["60"],
    components: {
        card: { background: gray[0] },
        input: {
            placeholderColor: overlays[800]["20"],
            border: borderSm,
            color: text,
        },
    },
    text,
    lightText: light,
};
